import { useEditorStore } from '../../store/editorStore';
import { CaptionsDialog } from './CaptionsDialog';
import { CommandPalette } from './CommandPalette';
import { ExportDialog } from './ExportDialog';
import { NewProjectDialog } from './NewProjectDialog';
import { ProjectsDialog } from './ProjectsDialog';
import { SettingsDialog } from './SettingsDialog';

export function ModalHost() {
  const modal = useEditorStore((state) => state.modal);
  if (modal === 'command') return <CommandPalette />;
  if (modal === 'export') return <ExportDialog />;
  if (modal === 'new-project') return <NewProjectDialog />;
  if (modal === 'projects') return <ProjectsDialog />;
  if (modal === 'settings') return <SettingsDialog />;
  if (modal === 'captions') return <CaptionsDialog />;
  return null;
}
